import { AnyPlan, DigitalEntry } from '../../types';

export type GetCountryDataFn = (plan: AnyPlan, country: string) => any;

export const getScenarios = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): string[] =>
  plans.map((plan) => getCountryData(plan, country)?.campaignScenario ?? 'N/A');

export const getTargetGroups = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): string[] =>
  plans.map((plan) => getCountryData(plan, country)?.targetGroup ?? 'N/A');

export const getSegmentsJoined = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): string[] =>
  plans.map((plan) => {
    const segs = getCountryData(plan, country)?.segments ?? [];
    return segs.length ? segs.map((s: any) => s.title).join('\n') : 'N/A';
  });

export type TVStatusValue = {
  main: string;
  sub: string;
};

export const getTVStatusValues = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): TVStatusValue[] =>
  plans.map((plan) => {
    const countryData = getCountryData(plan, country);
    const tvAvailable = countryData?.availableTouchpoints?.some(
      (tp: any) => tp.TouchpointName === 'TV'
    );

    if (!tvAvailable) return { main: 'NO', sub: '(NOT AN OPTION)' };
    if (countryData?.isTVMandatory) return { main: 'YES', sub: '(MANDATORY)' };
    if (countryData?.isTVIncluded === true)
      return { main: 'YES', sub: '(MANUALLY SELECTED)' };
    if (countryData?.isTVIncluded === false)
      return { main: 'NO', sub: '(MANUALLY SELECTED)' };
    return { main: 'N/A', sub: '' };
  });

export type DigitalBudgetTotal = {
  sum: number;
  currency?: string;
};

export const getDigitalBudgetTotals = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): DigitalBudgetTotal[] =>
  plans.map((plan) => {
    const countryData = getCountryData(plan, country);
    const digital: DigitalEntry[] = countryData?.calculatedBudget ?? [];

    let sum = 0;
    let currency: string | undefined;

    digital.forEach((element) => {
      const val = element?.budget?.value;
      if (typeof val === 'number') {
        sum += val;
        if (!currency && element.budget?.currency) {
          currency = element.budget.currency;
        }
      }
    });

    return { sum, currency };
  });

export const getDigitalBudgetSums = (totals: DigitalBudgetTotal[]): number[] =>
  totals.map((total) => total.sum);

export const getDigitalBudgetData = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
) => {
  const totals = getDigitalBudgetTotals(plans, country, getCountryData);
  const sums = getDigitalBudgetSums(totals);
  return { totals, sums };
};
